export default "__VITE_ASSET__cfe42852__"